// extracted by mini-css-extract-plugin
export default {"container":"src-constrains-HtmlToText-css-module__container--pmxBs"};